/**
 * Map a transaction/bank category name to an icon name from
 * components/ui/icon/icon.vue.
 *
 * Per the v2 Figma dev note ("Categories from bank data. Use the same icons
 * as in feature Best Cards By Category"), this reuses the Best Cards icon
 * vocabulary. Matching is keyword-based because warehouse (MX) category
 * names vary ("Restaurants & Bars", "Fast Food", "Gas & Fuel", ...).
 */
const KEYWORD_ICONS = [
    { icon: 'dining', keywords: ['dining', 'restaurant', 'food', 'coffee', 'bar'] },
    { icon: 'basket', keywords: ['grocer', 'supermarket', 'wholesale'] },
    { icon: 'airplane', keywords: ['airfare', 'airline', 'air travel', 'flight'] },
    { icon: 'hotel', keywords: ['hotel', 'lodging', 'accommodation'] },
    { icon: 'suitcase', keywords: ['travel', 'cruise', 'vacation', 'trip'] },
    { icon: 'gas', keywords: ['gas', 'fuel'] },
    { icon: 'car', keywords: ['auto', 'transit', 'taxi', 'rideshare', 'ride share', 'parking', 'toll', 'transport', 'car rental'] },
    { icon: 'ticket', keywords: ['entertainment', 'recreation', 'movie', 'music', 'event'] },
    { icon: 'heart', keywords: ['health', 'fitness', 'medical', 'pharmacy', 'drugstore', 'dental', 'doctor'] },
    { icon: 'building', keywords: ['home', 'utilities', 'rent', 'mortgage', 'insurance'] },
    { icon: 'tag', keywords: ['shopping', 'retail', 'department store', 'clothing'] },
];

// Per the v2 dev note: "If there is no appropriate icon, use as placeholder icon 'grid'".
const FALLBACK_ICON = 'grid';

/**
 * @param {string|null|undefined} category
 * @returns {string} icon name for components/ui/icon/icon.vue
 */
export function iconForCategory(category) {
    const normalized = (category || '').toLowerCase();

    if (!normalized) {
        return FALLBACK_ICON;
    }

    for (const { icon, keywords } of KEYWORD_ICONS) {
        if (keywords.some((keyword) => normalized.includes(keyword))) {
            return icon;
        }
    }

    return FALLBACK_ICON;
}
